import { createFileRoute } from "@tanstack/react-router";

import TermsOfService from "@/containers/TermsOfService";

export const Route = createFileRoute("/terms")({
  component: () => <TermsOfService />,
});
